import type { PersistentState } from "../../types/PersistentState";
import { getStorage } from "../../lib/CookieConsent";
import { CHAT_MESSAGES_LOCAL_STORAGE_KEY } from "../../config";
import { sendCustomError } from "../../lib/ApplicationPerormanceMonitoring";

/**
 *
 */
export async function saveStateToStorage(state: PersistentState) {
    const storage = await getStorage();
    const success = storage.instance?.setJson<PersistentState>(CHAT_MESSAGES_LOCAL_STORAGE_KEY, state);
    if (!success) {
        sendCustomError("nucleus-cassandra-client-storage", "Failed to save chat messages to storage", {
            storage: storage?.type,
        });
    }
}

/**
 *
 */
export async function getStateFromStorage(): Promise<PersistentState | undefined> {
    const storage = await getStorage();
    const rawState = storage?.instance.getJson<PersistentState>(CHAT_MESSAGES_LOCAL_STORAGE_KEY);

    if (rawState) {
        return rawState;
    }
}